import { DEFAULT_PAGE_SETUP, type AuthUser, type DocMeta, type SaveStatus } from './types';

// ═══════════════════════════════════════════════════════════════
// Minimalistický reaktivní store bez frameworku.
// Vanilla SPA dle specifikace — žádný React. Jednoduchý pub/sub.
// ═══════════════════════════════════════════════════════════════

export interface AppState {
  user: AuthUser | null;
  authChecked: boolean;
  doc: DocMeta;
  saveStatus: SaveStatus;
  wordCount: number;
  zoom: number; // 1.0 = 100 %
}

type Listener = (state: AppState) => void;

function createInitialState(): AppState {
  return {
    user: null,
    authChecked: false,
    doc: {
      name: 'Nepojmenovaný dokument',
      source: 'unsaved',
      dirty: false,
      pageSetup: { ...DEFAULT_PAGE_SETUP, margins: { ...DEFAULT_PAGE_SETUP.margins } },
    },
    saveStatus: 'idle',
    wordCount: 0,
    zoom: 1.0,
  };
}

class Store {
  private state: AppState = createInitialState();
  private listeners = new Set<Listener>();

  get(): Readonly<AppState> {
    return this.state;
  }

  /** Shallow-merge patch a notifikace odběratelů. */
  set(patch: Partial<AppState>): void {
    this.state = { ...this.state, ...patch };
    this.emit();
  }

  /** Patch vnořeného objektu `doc`. */
  patchDoc(patch: Partial<DocMeta>): void {
    this.state = { ...this.state, doc: { ...this.state.doc, ...patch } };
    this.emit();
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }

  private emit(): void {
    for (const fn of this.listeners) fn(this.state);
  }
}

export const store = new Store();
